/* Fiche « Avera™ Magic Body Oil » : copie conforme de la fiche Evora « Botanical Body Oil » (01/10/2026).
   Le contenu vit dans le shadow DOM de <amo-page> (sections/amo-page.liquid). Ce fichier reprend, à
   l'identique, les comportements de la source (thème Impact + scripts de leurs sections), portés sur le
   shadow root : galerie, sélecteur d'offre (achat unique, pas d'abonnement), « ADD TO CART » (vide le
   panier, ajoute, passe au paiement, comme chez Evora), barre collante, pop-up « real results », slider
   de commentaires Facebook + visionneuse, vidéo, « view all » des ingrédients, widget d'avis Loox recopié. */
(function () {
  'use strict';
  var host = document.querySelector('amo-page');
  if (!host || !host.shadowRoot) return;
  var root = host.shadowRoot;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var htmlEl = $('amo-html');
  var bodyEl = $('amo-body');
  var product = {};
  try { product = JSON.parse(document.getElementById('amo-product-json').textContent); } catch (e) {}

  /* ---------- Hauteurs collantes : le header d'Avera remplace celui d'Evora ---------- */
  function syncSticky() {
    var header = document.querySelector('.shopify-section-group-header-group header, sticky-header, .shopify-section-header-sticky, #shopify-section-header');
    var h = 0, sticky = 0;
    if (header) {
      var cs = getComputedStyle(header.closest('.shopify-section') || header);
      h = Math.round(header.getBoundingClientRect().height);
      sticky = (cs.position === 'sticky' || cs.position === 'fixed') ? 1 : 0;
    }
    htmlEl.style.setProperty('--header-height', h + 'px');
    htmlEl.style.setProperty('--sticky-header-enabled', String(sticky));
    htmlEl.style.setProperty('--announcement-bar-height', '0px');
  }
  syncSticky();
  window.addEventListener('resize', syncSticky);

  /* ---------- Argent : même format que la page (« $54 », sans décimales nulles) ---------- */
  function money(cents) {
    var cur = host.getAttribute('data-currency') || 'USD';
    var v = Number(cents || 0) / 100;
    var whole = Math.round(v * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(v);
    } catch (e) { return '$' + (whole ? v.toFixed(0) : v.toFixed(2)); }
  }

  /* ---------- <scroll-shadow> d'Impact : dégradés aux bords de la bande de miniatures quand elle défile (code du thème source) ---------- */
  (function () {
    if (!('ResizeObserver' in window) || window.customElements.get('amo-scroll-shadow')) return;
    var TPL = '<style>:host{display:inline-block;contain:layout;position:relative}:host([hidden]){display:none}' +
      's{position:absolute;top:0;bottom:0;left:0;right:0;pointer-events:none;background-image:' +
      'var(--scroll-shadow-top,linear-gradient(to bottom,rgb(var(--background)),rgb(var(--background) / 0))),' +
      'var(--scroll-shadow-bottom,linear-gradient(to top,rgb(var(--background)),rgb(var(--background) / 0))),' +
      'var(--scroll-shadow-left,linear-gradient(to right,rgb(var(--background)),rgb(var(--background) / 0))),' +
      'var(--scroll-shadow-right,linear-gradient(to left,rgb(var(--background)),rgb(var(--background) / 0)));' +
      'background-position:top,bottom,left,right;background-repeat:no-repeat;' +
      'background-size:100% var(--top,0),100% var(--bottom,0),var(--left,0) 100%,var(--right,0) 100%}</style><slot></slot><s></s>';
    function throttle(fn) { var pending = false; return function () { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; fn(); }); }; }
    function Updater(target) {
      var self = this;
      this.scheduleUpdate = throttle(function () { self.update(target, getComputedStyle(target)); });
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
    }
    Updater.prototype.start = function (el) {
      if (this.element) this.stop();
      if (el) { el.addEventListener('scroll', this.scheduleUpdate); this.resizeObserver.observe(el); this.element = el; }
    };
    Updater.prototype.stop = function () {
      if (!this.element) return;
      this.element.removeEventListener('scroll', this.scheduleUpdate); this.resizeObserver.unobserve(this.element); this.element = null;
    };
    Updater.prototype.update = function (target, style) {
      var el = this.element;
      if (!el) return;
      var max = style.getPropertyValue('--scroll-shadow-size') ? parseInt(style.getPropertyValue('--scroll-shadow-size'), 10) : 0;
      var s = { top: Math.max(el.scrollTop, 0), bottom: Math.max(el.scrollHeight - el.offsetHeight - el.scrollTop, 0),
        left: Math.max(el.scrollLeft, 0), right: Math.max(el.scrollWidth - el.offsetWidth - el.scrollLeft, 0) };
      requestAnimationFrame(function () { ['top', 'bottom', 'left', 'right'].forEach(function (p) { target.style.setProperty('--' + p, (s[p] > max ? max : s[p]) + 'px'); }); });
    };
    class AmoScrollShadow extends HTMLElement {
      constructor() { super(); this.attachShadow({ mode: 'open' }).innerHTML = TPL; this.updater = new Updater(this.shadowRoot.lastElementChild); this.start = this.start.bind(this); }
      connectedCallback() { this.shadowRoot.querySelector('slot').addEventListener('slotchange', this.start); this.start(); }
      disconnectedCallback() { this.updater.stop(); }
      start() { if (this.firstElementChild) this.updater.start(this.firstElementChild); }
    }
    window.customElements.define('amo-scroll-shadow', AmoScrollShadow);
  })();

  /* ---------- Galerie (media-carousel + page-dots d'Impact) ---------- */
  (function gallery() {
    var list = $('amo-media-carousel');
    if (!list) return;
    var slides = $$('.product-gallery__media', list);
    var thumbs = $$('.product-gallery__thumbnail');
    var cursor = $('amo-custom-cursor');
    var index = 0;
    slides.forEach(function (s, i) { s.classList.toggle('is-selected', i === 0); });
    // classe posée par le scroll-area d'Impact quand le carrousel déborde (des règles CSS en dépendent)
    function scrollable() { list.classList.toggle('is-scrollable', list.scrollWidth > list.clientWidth); }
    scrollable();
    window.addEventListener('resize', scrollable);

    function select(i, smooth) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      var target = slides[index];
      list.scrollTo({ left: target.offsetLeft - list.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(index);
    }
    function mark(i) {
      slides.forEach(function (s, k) { s.classList.toggle('is-selected', k === i); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var active = thumbs[i];
      var strip = active && active.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: active.offsetLeft - strip.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
      }
      if (list.hasAttribute('adaptive-height') && slides[i]) {
        var img = slides[i].querySelector('img');
        if (img && img.complete) list.style.height = slides[i].getBoundingClientRect().height + 'px';
      }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { select(k); }); });
    var raf = 0;
    list.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = list.clientWidth || 1;
        var i = Math.round(list.scrollLeft / w);
        if (i !== index) { index = i; mark(i); }
      });
    }, { passive: true });
    window.addEventListener('resize', function () { select(index, false); });

    // curseur personnalisé (desktop) : suit la souris sur l'image, clic = image suivante / précédente
    if (cursor) {
      var wrap = cursor.parentElement;
      wrap.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = wrap.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        cursor.style.translate = x + 'px ' + y + 'px';
        cursor.classList.add('is-visible');
        cursor.classList.toggle('is-half-start', x < r.width / 2);
      });
      wrap.addEventListener('pointerleave', function () { cursor.classList.remove('is-visible'); });
      list.addEventListener('click', function (e) {
        if (!window.matchMedia('(pointer: fine)').matches) return;
        var r = list.getBoundingClientRect();
        if (e.clientX - r.left < r.width / 2) select(index - 1); else select(index + 1);
      });
    }
  })();

  /* ---------- Offre : achat unique (pas de plan d'abonnement) ---------- */
  var inputs = $$('.custom-variant-input');
  function checkedInput() { return $('.custom-variant-input:checked') || inputs[0]; }
  function syncOffer() {
    var c = checkedInput();
    if (!c) return;
    // l'offre cochée est stylée en CSS (:has(input:checked)), comme chez la source
    var price = c.getAttribute('data-variant-price');
    var compare = c.getAttribute('data-variant-compare-at-price');
    var bn = $('#buy-now-price'), bc = $('#buy-now-compare-at-price');
    if (bn && price) bn.textContent = price;
    if (bc) bc.textContent = (compare && compare !== price) ? compare : '';
    var available = c.getAttribute('data-available') === 'true';
    var buy = $('#buy-now-button');
    if (buy) buy.classList.toggle('cvp-hidden', !available);
    syncStickyBar();
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', c.value);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }
  inputs.forEach(function (i) { i.addEventListener('change', syncOffer); });

  // « ADD TO CART » : ajout au panier puis ouverture du panier latéral d'Avera (demande de Jordan, 02/10), comme le
  // formulaire produit du thème : POST /cart/add avec la section du tiroir, puis « cart:updated » (le tiroir se redessine,
  // l'icône panier l'ouvre). La roue de chargement d'Evora tourne jusqu'à l'ouverture du tiroir.
  var buyBtn = $('#buy-now-button');
  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      var c = checkedInput();
      if (!c || buyBtn.classList.contains('is-loading')) return;
      buyBtn.classList.add('is-loading');
      var drawer = document.querySelector('cart-drawer');
      var icon = document.querySelector('cart-icon');
      var before = icon && icon.getCurrentItemCount ? icon.getCurrentItemCount() : NaN;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || root + 'cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(c.value), quantity: 1 }], sections: drawer ? drawer.dataset.sectionId : '' })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && Number(res.status) >= 400) throw new Error(res.description || res.message || 'Add to cart failed');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: {
            itemCount: isNaN(before) ? undefined : before + 1, source: 'product-form', variantId: c.value, sections: res.sections } } }));
          if (drawer && drawer.open && !(drawer.isOpen && drawer.isOpen())) drawer.open();
        })
        .catch(function (err) {
          document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: err.message || String(err) } }));
        })
        .then(function () { buyBtn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Barre collante (SHOP NOW -> retour à la zone d'achat) ---------- */
  var bar = $('#satc');
  function syncStickyBar() {
    var c = checkedInput();
    if (!c) return;
    var p = $('#sticky-atc-price'), cp = $('#sticky-atc-compare');
    var price = Number(c.getAttribute('data-price-cents'));
    var compare = Number(c.getAttribute('data-compare-cents'));
    if (p) p.textContent = money(price);
    if (cp) {
      if (compare && compare > price) { cp.textContent = money(compare); cp.classList.remove('is-hidden'); }
      else { cp.textContent = ''; cp.classList.add('is-hidden'); }
    }
  }
  if (bar) {
    var stickyBtn = $('#sticky-atc-btn');
    function isVisible(el) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
    function toggleBar() {
      var buyBox = $('.product-info');
      if (!buyBox) return;
      bar.classList.toggle('show', window.scrollY > 400 && !isVisible(buyBox));
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var buyBox = $('.product-info');
      if (!buyBox) return;
      window.scrollTo({ top: buyBox.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
    });
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    toggleBar();
    // barre masquée quand un tiroir du thème Avera (panier, menu) est ouvert
    var mo = new MutationObserver(function () {
      var open = document.querySelector('cart-drawer.is-open, cart-drawer[open], cart-drawer.active, details[open] > .drawer, .drawer[open]');
      bar.style.visibility = open ? 'hidden' : '';
    });
    mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
  }
  syncOffer();

  /* ---------- « 🇺🇸 | Free Shipping to United States » : pays détecté par Shopify, comme le script de la source.
     Affiché seulement pour les pays où la livraison du produit est réellement offerte (profil « Magic Body Oil »). ---------- */
  (function () {
    var p = root.getElementById('locationinfop');
    if (!p || !window.fetch) return;
    var FLAGS = {"US":"🇺🇸","CA":"🇨🇦","FR":"🇫🇷","NL":"🇳🇱","DE":"🇩🇪","GB":"🇬🇧","IT":"🇮🇹","ES":"🇪🇸","CN":"🇨🇳","JP":"🇯🇵","BR":"🇧🇷","IN":"🇮🇳","RU":"🇷🇺","ZA":"🇿🇦","AU":"🇦🇺","NZ":"🇳🇿","MX":"🇲🇽","AR":"🇦🇷","CL":"🇨🇱","CO":"🇨🇴","PE":"🇵🇪","VE":"🇻🇪","EC":"🇪🇨","GT":"🇬🇹","HN":"🇭🇳","SA":"🇸🇦","AE":"🇦🇪","TR":"🇹🇷","TH":"🇹🇭","MY":"🇲🇾","SG":"🇸🇬","ID":"🇮🇩","PH":"🇵🇭","VN":"🇻🇳","KR":"🇰🇷","KP":"🇰🇵","SE":"🇸🇪","NO":"🇳🇴","FI":"🇫🇮","DK":"🇩🇰","IS":"🇮🇸","IE":"🇮🇪","CH":"🇨🇭","PT":"🇵🇹","BE":"🇧🇪","LU":"🇱🇺","PL":"🇵🇱","CZ":"🇨🇿","SK":"🇸🇰","HU":"🇭🇺","AT":"🇦🇹","LI":"🇱🇮","GR":"🇬🇷","BG":"🇧🇬","RO":"🇷🇴","UA":"🇺🇦","BY":"🇧🇾","LT":"🇱🇹","LV":"🇱🇻","EE":"🇪🇪","MD":"🇲🇩","AM":"🇦🇲","GE":"🇬🇪","AZ":"🇦🇿","IR":"🇮🇷","IQ":"🇮🇶","SY":"🇸🇾","LB":"🇱🇧","JO":"🇯🇴","IL":"🇮🇱","EG":"🇪🇬","MA":"🇲🇦","DZ":"🇩🇿","TN":"🇹🇳","LY":"🇱🇾","GM":"🇬🇲","SN":"🇸🇳","MR":"🇲🇷","ML":"🇲🇱","GN":"🇬🇳","CI":"🇨🇮","BF":"🇧🇫","NE":"🇳🇪","TG":"🇹🇬","BJ":"🇧🇯","NG":"🇳🇬","CM":"🇨🇲","GA":"🇬🇦","CG":"🇨🇬","CD":"🇨🇩","AO":"🇦🇴","GW":"🇬🇼","SC":"🇸🇨","SD":"🇸🇩","RW":"🇷🇼","ET":"🇪🇹","SO":"🇸🇴","DJ":"🇩🇯","KE":"🇰🇪","TZ":"🇹🇿","UG":"🇺🇬","BI":"🇧🇮","MZ":"🇲🇿","ZM":"🇿🇲","MW":"🇲🇼","LS":"🇱🇸","BW":"🇧🇼","NA":"🇳🇦","SZ":"🇸🇿"};
    var FREE = ['AE','AU','BE','CA','CH','CZ','DE','DK','ES','FI','FR','GB','HK','IE','IL','IT','JP','KR','MY','NL','NO','NZ','PL','PT','SE','SG','US'];
    fetch('/browsing_context_suggestions.json').then(function (r) { return r.json(); }).then(function (data) {
      var c = data.detected_values.country.handle, name = data.detected_values.country.name;
      if (FREE.indexOf(c) < 0) return;
      p.textContent = (FLAGS[c] || '📦') + ' | Free Shipping to ';
      var span = document.createElement('span');
      span.setAttribute('style', 'text-decoration: underline; color: black;font-weight:bold;');
      span.textContent = name;
      p.appendChild(span);
    }).catch(function () {});
  })();

  /* ---------- Note Loox : clic -> défilement jusqu'aux avis ---------- */
  $$('[data-amo-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = root.getElementById(a.getAttribute('data-amo-scroll'));
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 20, behavior: 'smooth' });
    });
  });

  /* ---------- Pop-up « Tap to see real results » (<dialog>) ---------- */
  $$('[data-amo-open]').forEach(function (b) {
    b.addEventListener('click', function () { var d = root.getElementById(b.getAttribute('data-amo-open')); if (d && d.showModal) d.showModal(); });
  });
  $$('dialog.rrp-dialog').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  });
  $$('[data-amo-close]').forEach(function (b) { b.addEventListener('click', function () { var d = b.closest('dialog'); if (d) d.close(); }); });

  /* ---------- Vidéo « How it works » (lecture auto, muette, en boucle) ---------- */
  $$('#shopify-section-template--18778448724027__custom_how_it_works_4UgwYt video').forEach(function (video) {
    video.muted = true; video.defaultMuted = true; video.loop = true; video.playsInline = true;
    video.setAttribute('muted', ''); video.setAttribute('loop', ''); video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', ''); video.setAttribute('preload', 'auto');
    if (video.readyState < 2) video.load();
    var p = video.play();
    if (p !== undefined) p.catch(function () { video.muted = true; video.play().catch(function () {}); });
  });

  /* ---------- Ingrédients : « view all » ---------- */
  $$('#shopify-section-template--18778448724027__custom_ingredients_rMqHRg .view-all-button').forEach(function (button) {
    button.addEventListener('click', function () {
      var expander = button.closest('.view-all-section').querySelector('.expander');
      button.classList.toggle('expanded');
      expander.classList.toggle('expanded');
    });
  });

  /* ---------- Commentaires Facebook : slider + visionneuse ---------- */
  (function () {
    var sid = 'template--18778448724027__fb_comments_npRUaa';
    var slider = root.getElementById('fbs-slider-' + sid);
    var dotsEl = root.getElementById('fbs-dots-' + sid);
    if (!slider) return;
    var items = Array.prototype.slice.call(slider.children);
    if (!items.length) return;
    var cur = 0;
    function pv() { return window.innerWidth >= 900 ? 3 : window.innerWidth >= 600 ? 2 : 1; }
    function pg() { return Math.ceil(items.length / pv()); }
    function buildDots() {
      dotsEl.innerHTML = '';
      for (var i = 0; i < pg(); i++) {
        var d = document.createElement('button');
        d.className = 'fbs-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Page ' + (i + 1));
        (function (idx) { d.addEventListener('click', function () { goTo(idx); }); })(i);
        dotsEl.appendChild(d);
      }
    }
    function goTo(idx) {
      cur = Math.max(0, Math.min(idx, pg() - 1));
      slider.style.transform = 'translateX(-' + (cur * pv() * (100 / items.length)) + '%)';
      Array.prototype.forEach.call(dotsEl.querySelectorAll('.fbs-dot'), function (d, i) { d.classList.toggle('active', i === cur); });
    }
    function layout() {
      slider.style.width = (items.length / pv() * 100) + '%';
      items.forEach(function (it) { it.style.width = (100 / items.length) + '%'; });
      buildDots(); goTo(cur);
    }
    var prev = root.getElementById('fbs-prev-' + sid), next = root.getElementById('fbs-next-' + sid);
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    layout();
    window.addEventListener('resize', layout);
    var sx = 0;
    slider.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) { var d = sx - e.changedTouches[0].clientX; if (Math.abs(d) > 40) goTo(d > 0 ? cur + 1 : cur - 1); });

    var lb = root.getElementById('fbs-lb-' + sid);
    if (!lb) return;
    var lbImg = root.getElementById('fbs-lb-img-' + sid);
    var lbP = root.getElementById('fbs-lb-prev-' + sid);
    var lbN = root.getElementById('fbs-lb-next-' + sid);
    var li = 0;
    function btns() { return Array.prototype.slice.call(root.querySelectorAll('.fbs-img-btn[data-section="' + sid + '"]')); }
    function setImg(idx) { var list = btns(); li = (idx + list.length) % list.length; lbImg.src = list[li].dataset.lightbox; }
    function openLb(src) {
      var list = btns();
      li = list.findIndex(function (b) { return b.dataset.lightbox === src; });
      if (li < 0) li = 0;
      setImg(li);
      lb.classList.add('active');
      document.documentElement.style.overflow = 'hidden';
      var many = list.length > 1;
      lbP.style.display = many ? '' : 'none';
      lbN.style.display = many ? '' : 'none';
    }
    function closeLb() { lb.classList.remove('active'); document.documentElement.style.overflow = ''; lbImg.src = ''; }
    btns().forEach(function (b) { b.addEventListener('click', function () { openLb(b.dataset.lightbox); }); });
    lb.querySelector('.fbs-lb-backdrop').addEventListener('click', closeLb);
    lb.querySelector('.fbs-lb-close').addEventListener('click', closeLb);
    lbP.addEventListener('click', function () { setImg(li - 1); });
    lbN.addEventListener('click', function () { setImg(li + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('active')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') setImg(li - 1);
      if (e.key === 'ArrowRight') setImg(li + 1);
    });
  })();

  /* ---------- Avis Loox recopiés ----------
     Le widget (document recopié, injecté en srcdoc) parle à la page par postMessage, comme chez la source avec le
     script Loox : 'resize' (hauteur de l'iframe), 'quickview' (aperçu d'un avis par-dessus la page), 'closeModal',
     'scroll_to_view'. Ce bloc reprend le comportement du script Loox de la source (overlay, iframe, historique). */
  (function () {
    var frame = root.getElementById('looxReviewsFrame');
    if (!frame) return;
    function loadScript(src, cb) {
      var sc = document.createElement('script');
      sc.src = src;
      sc.onload = cb;
      document.head.appendChild(sc);
    }
    // le document du widget est chargé à l'approche de la section
    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      loadScript(frame.getAttribute('data-amo-loox'), function () { if (window.AMO_LOOX_HTML) frame.srcdoc = window.AMO_LOOX_HTML; });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '1200px 0px' });
      io.observe(frame);
    } else { load(); }

    // aperçus des avis : chargés au premier clic sur un avis
    var qvWait = null;
    function qvData(cb) {
      if (window.AMO_LOOX_QV) return cb(window.AMO_LOOX_QV);
      if (qvWait) return qvWait.push(cb);
      qvWait = [cb];
      loadScript(frame.getAttribute('data-amo-loox-qv'), function () { qvWait.forEach(function (f) { f(window.AMO_LOOX_QV); }); });
    }
    var PREFIX = 'looxOverlay', lastActiveEl = null, ignorePopState = false;
    function closeModal() {
      var el = document.getElementById(PREFIX + '_quickview');
      if (el) el.parentNode.removeChild(el);
      document.body.classList.remove('loox-overlay-is-active');
      if (!document.getElementsByClassName('loox-overlay').length) { document.body.style.overflow = ''; document.body.style.position = ''; }
      if (lastActiveEl) { if (lastActiveEl.focus) lastActiveEl.focus(); lastActiveEl = null; }
    }
    window.addEventListener('popstate', function () { if (!ignorePopState) closeModal(); ignorePopState = false; });
    window.addEventListener('focus', function (e) {
      var t = e.target;
      if (!t.classList || !t.classList.contains('loox-iframe-focus-trap')) return;
      var f = document.getElementById(t.getAttribute('data-frame-id'));
      if (f) f.focus();
    }, true);
    function openQV(postId) {
      qvData(function (qv) {
        var item = qv && qv.items[postId];
        if (!item || document.getElementById(PREFIX + '_quickview')) return;
        lastActiveEl = document.activeElement;
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        var a = document.createElement('div');
        a.setAttribute('aria-modal', 'true');
        a.id = PREFIX + '_quickview';
        a.classList.add('loox-overlay');
        a.setAttribute('data-post-id', postId);
        a.style.cssText = 'width: 100%;height:100%; position:fixed; font-family: Arial, Helvetica, sans-serif;top: 0;right: 0;bottom: 0;left: 0;z-index: 2147483646;opacity: 1;-webkit-transition: opacity 400ms ease-in;-moz-transition: opacity 400ms ease-in;transition: opacity 400ms ease-in;overflow-y:scroll;-webkit-overflow-scrolling: touch;background: rgba(0, 0, 0, 0.7);';
        a.innerHTML = '<div style="position:relative;min-height:' + (iOS ? '101%' : '100%') + ';max-width:100%;margin: 0 auto 0;">' +
          '<div class="loox-iframe-focus-trap" style="position:absolute; width:1px; top:0; left:0; height:1px; z-index:1000; display:block;" tabindex="0" data-frame-id="quickview"></div>' +
          '<iframe id="quickview" height="99vh" width="100%" frameborder="0" scrolling="no" margin="0" style="overflow:hidden;height:99vh;width:1px;min-width:100%;color-scheme:none;min-height: 600px;overflow: auto" allowfullscreen="true" title="Review quick view" allow="web-share; clipboard-read; clipboard-write"></iframe>' +
          '<div class="loox-iframe-focus-trap" style="position:absolute; bottom:0; right:0; width:1px; height:1px; z-index:1000; display:block;" tabindex="0" data-frame-id="quickview"></div></div>';
        a.querySelector('iframe').srcdoc = qv.shells[item.s]
          .replace('@@POST@@', function () { return postId; })
          .replace('@@SWIPER@@', function () { return qv.swiper; })
          .replace('@@REVIEW@@', function () { return item.h; });
        try { history.pushState({ url: 'quickview' }, '', '#qv' + postId); document.body.style.overflow = 'hidden'; } catch (e) { window.location.hash = '#qv' + postId; }
        document.body.appendChild(a);
        var f = document.getElementById('quickview');
        if (f && f.contentWindow && f.contentWindow.focus) f.contentWindow.focus();
      });
    }
    window.addEventListener('message', function (e) {
      var qvf = document.getElementById('quickview');
      if (e.source !== frame.contentWindow && !(qvf && e.source === qvf.contentWindow)) return;
      var n = e.data;
      if (typeof n === 'string' && n.indexOf('{') === 0) { try { n = JSON.parse(n); } catch (er) { return; } }
      if (!n || typeof n !== 'object') return;
      if (n.type === 'resize') {
        var s = n.frame === 'quickview' ? qvf : (n.frame === frame.id ? frame : null);
        if (!s) return;
        if (n.to === 'visualViewport') {
          var d = window.visualViewport ? window.visualViewport.height : window.innerHeight;
          s.height = d; s.style.height = d + 'px'; s.parentNode.style.height = d + 'px'; s.style.minHeight = ''; s.parentNode.style.minHeight = '';
          return;
        }
        var l = (n.height + 'px').replace('vhpx', 'vh').replace('%px', '%');
        s.height = l; s.style.height = l; s.parentNode.style.height = l;
        if (n.minHeight !== undefined) { var m = (n.minHeight + 'px').replace('vhpx', 'vh').replace('%px', '%'); s.style.minHeight = m; s.parentNode.style.minHeight = m; }
      }
      if (n.type === 'scroll_to_view') {
        var t = root.getElementById('looxReviews');
        if (t) window.scrollTo(0, t.getBoundingClientRect().top + window.scrollY);
      }
      if (n.type === 'closeModal') { ignorePopState = true; history.back(); closeModal(); }
      if (n.type === 'quickview') openQV(n.postId);
      if (n.type === 'store-review-quickview') openQV(n.storeReviewId);
    });
  })();
})();
